import UserSectionMenu from "../../components/UserSectionMenu";
import UserInformation from "../../components/UserInformation";
import Pagination from "../../components/Pagination";
import AddDriverForm from "./AddDriverForm";
import { useEffect, useState } from "react";
import { MyContext } from "../../context/myContext";
import HistoryPopUp from "../../components/HistoryPopUp";
import AddUserBox from "../../components/AddUserBox";
import { useDispatch, useSelector } from "react-redux";
import {
  getDriverHistory,
  getDrivers,
  selectDriverBodyArray,
  selectDriverHistoryArray,
  selectSelectedDriver,
  setDriverInfo,
  setDriverInputsState,
} from "./driverSlice";
import {
  callApiAgain,
  getCities,
  getExcel,
  selectCallApi,
  selectShowEditForm,
  selectShowForm,
  selectShowHistory,
  showPopUp,
} from "../common-states/commonStatesSlice";
import { handleShowPopUp } from "../common-states/handleShowPopUp";
import { toGregorian } from "jalaali-js";

const DriverManagement = () => {
  const headArray = [
    "حذف",
    "ویرایش",
    "سوابق",
    "حجم تانکر آب",
    "شهر",
    "شماره تماس",
    "کد ملی",
    "نام و نام خانوادگی",
    "ردیف",
  ];
  const driverHistoryTableHead = [
    "هزینه",
    "حجم آب",
    "زمان تحویل",
    "تاریخ تحویل",
    "زمان درخواست",
    "نوع آب",
    "منطقه",
    "کد پیگیری",
    "شماره تلفن متقاضی",
    "نام درخواست دهنده",
    "ردیف",
  ];
  const [driver, setDriver] = useState({ id: null, name: "" });
  const dispatch = useDispatch();
  const showForm = useSelector(selectShowForm);
  const showEditForm = useSelector(selectShowEditForm);
  const showHistory = useSelector(selectShowHistory);
  const bodyArray = useSelector(selectDriverBodyArray);
  const historyArray = useSelector(selectDriverHistoryArray);
  const selectedDriver = useSelector(selectSelectedDriver);
  const callApi = useSelector(selectCallApi); //this state will be updated to get drivers again when a new driver is added in addDriverForm
  const [state, setState] = useState({
    selectedValue: { term: "", city: "" },
    input: "",
    emptyInputAlert: false,
    emptySelectAlert: false,
    isSearched: false,
  });
  const handleShowForm = (item) => {
    console.log('driver',driver)
    setDriver({ ...driver, id: item.driver_id });
    dispatch(showPopUp({ type: "showEditForm", value: !showEditForm }));
    if (showForm === false) {
      let editFormState = {
        code: item.national_code,
        name: item.name,
        tankVolume: item.water_source_volume,
        mobile: item.mobile,
        city: item.city_id,
        province: item.province,
        driverType: item.driver_type === 0 ? "بخش دولتی" : "بخش خصوصی",
        numberPlate: item.plate,
        description: item.description,
      };
      dispatch(setDriverInputsState(editFormState));
    }
  };
  const handleShowHistory = (item) => {
    setDriver({ ...driver, name: item.name,id:item.driver_id });
    dispatch(showPopUp({ type: "showHistory", value: !showHistory }));
    if (showHistory === false) {
      dispatch(getDriverHistory(item.driver_id));
    }
  };

  const handleClosePopup = () => {
    handleShowPopUp(dispatch, showForm, showEditForm, showHistory);
  };

  const handleGetExcel = (cityId) => {
    let items = [
      { item: "row", col_name: "ردیف" },
      { item: "created_at", col_name: "تاریخ ثبت" },
      { item: "city_id", col_name: "شهر" },
      { item: "name", col_name: "راننده" },
      { item: "driver_type", col_name: "نوع راننده" },
      { item: "national_code", col_name: "کدملی" },
    ];
    const data = {
      city_id: cityId === "" ? null : cityId,
      sheet_type: 2,
      items,
    };
    dispatch(getExcel(data));
  };

  const handleChangePage = (item) => {
    dispatch(getDrivers({ searchParam: "", pageNum: item, dispatch }));
  };

  const handleSearch = (searchParam) => {
    dispatch(getDrivers({ searchParam, pageNum: 1, dispatch }));
  };

  useEffect(() => {
    dispatch(getDrivers({ searchParam: "", pageNum: 1, dispatch }));
    dispatch(callApiAgain(false));
    // eslint-disable-next-line
  }, [callApi]);

  useEffect(() => {
    if (selectedDriver.obj !== null) {
      if (selectedDriver.type === "showEditForm") {
        handleShowForm(selectedDriver.obj);
      } else if (selectedDriver.type === "showHistory") {
        handleShowHistory(selectedDriver.obj);
      }
      dispatch(setDriverInfo({ obj: null, type: "" }));
    }
    // eslint-disable-next-line
  }, [selectedDriver]);
  useEffect(() => {
    dispatch(getCities());
  }, []);
  const [persianDate, setPersianDate] = useState({
    startDate: "0621-03-21",
    endDate: "0621-03-21",
  });
  const persianToEnglishNumber = (str) => {
    if (!str) return "";
    const persianNumbers = "۰۱۲۳۴۵۶۷۸۹";
    const englishNumbers = "0123456789";
    return str.replace(
      /[۰-۹]/g,
      (char) => englishNumbers[persianNumbers.indexOf(char)],
    );
  };
  const convertPersianToMiladi = (persianDateStr) => {
    const englishDigitDate = persianToEnglishNumber(persianDateStr);
    const parts = englishDigitDate.split(/[\/\-]/);
    if (parts.length !== 3) {
      throw new Error(
        "Invalid Persian date format. Use YYYY/MM/DD or YYYY-MM-DD",
      );
    }
    const jy = parseInt(parts[0], 10);
    const jm = parseInt(parts[1], 10);
    const jd = parseInt(parts[2], 10);
    const { gy, gm, gd } = toGregorian(jy, jm, jd);
    // Return as YYYY-MM-DD string (no time, no Z)
    return `${gy}/${String(gm).padStart(2, "0")}/${String(gd).padStart(2, "0")}`;
  };

  return (
    <div className="driver-box bg-white rounded-md p-2 sm:p-6">
      <div
        className={`${(showForm || showEditForm || showHistory) && "visible bg-slate-700 opacity-50"} dark-background`}
        onClick={handleClosePopup}
      ></div>
      <MyContext.Provider
        value={{
          showHistory,
          handleShowHistory,
          headArray: driverHistoryTableHead,
          bodyArray: historyArray,
          title: `سوابق راننده: آقای ${driver.name}`,
        }}
      >
        <HistoryPopUp
          persianDate={persianDate}
          setPersianDate={setPersianDate}
          excelData={{
            items: [
              { item: "row", col_name: "ردیف" },
              { item: "created_at", col_name: "تاریخ ثبت" },
              { item: "city_id", col_name: "شهر" },
              { item: "water_type", col_name: "نوع آب" },
              { item: "driver_id", col_name: "راننده" },
              { item: "nomad_id", col_name: "متقاضی" },
              { item: "settlement_status", col_name: "وضعیت تسویه" },
              { item: "driver_delivered_at", col_name: "زمان تایید راننده" },
              { item: "nomad_confirmed_at", col_name: "زمان تحویل عشایر" },
              { item: "description", col_name: "توضیحات" },
            ],
            sheet_type: 3,
            driver_id: driver?.id,
            start_created_at: convertPersianToMiladi(persianDate?.startDate),
            end_created_at: convertPersianToMiladi(persianDate?.endDate),
          }}
        />
      </MyContext.Provider>
      <MyContext.Provider
        value={{
          formTitle: "ویرایش راننده",
          showEditForm,
          handleShowForm,
          registerBtn: "ویرایش",
          driverId: driver.id,
        }}
      >
        <AddUserBox formComponent={AddDriverForm} />{" "}
        {/*this is for editDriverPopup*/}
      </MyContext.Provider>
      <UserSectionMenu
        state={state}
        setState={setState}
        buttonText="افزودن راننده جدید"
        formTitle="افزودن راننده جدید"
        formComponent={AddDriverForm}
        getSearchedInfo={handleSearch}
        handleGetExcel={handleGetExcel}
      />
      <MyContext.Provider
        value={{ headArray, bodyArray, title: "مشخصات رانندگان ثبت شده" }}
      >
        <UserInformation />
      </MyContext.Provider>
      <Pagination handleChangePage={handleChangePage} callApi={callApi} />
    </div>
  );
};

export default DriverManagement;
